import {Log, LogTag} from "../Log";
import html2canvas from 'html2canvas';
import {HttpClient} from "@angular/common/http";
import {Injector} from "@angular/core";
import {of, switchMap} from "rxjs";
import {Extension} from "./Extension";
import {ChromeExtension} from "./ChromeExtension";



export class Watchdog {
  extensionVersion = "";
  httpClient: HttpClient;
  playerChannel$;
  pingInterval = null;
  appType;
  memoryLeak;
  countSlowFPS = 0;
  extension: Extension;

  wdExtension: String;
  wdNative: String;
  wdConnected: String;

  constructor(injector: Injector, extension, playerChannel$) {
    this.httpClient = injector.get(HttpClient);
    this.extension = extension;
    this.playerChannel$ = playerChannel$;
  }

  start() {
    const logInfo = Log.getLogInfo("Watchdog", "start", []);
    const canvases = document.getElementsByTagName("canvas");
    if (canvases.length === 1) {
      const canvas = canvases[0];
      /*
      canvas.addEventListener('webglcontextlost', (event) => {
        if (this.pingInterval != null) {
          clearInterval(this.pingInterval);
          this.pingInterval = null;
        }
        location.reload();
      });

       */
    }


    this.extension.connect().pipe(
      switchMap( r=> {
        return this.extension.call('start', {appType: this.appType});
      })
    ).subscribe(ret => {
      if (ret != null) {
        let cmd: any = { cmd: 'watchdog', connected: "1" };
        this.wdConnected = "1";
        try {
          localStorage['deployment'] = JSON.stringify({ prompt: false });

          this.extensionVersion = ""
          const info = JSON.parse(ret)
          if (info.extension!=null) {
            this.extensionVersion += "Extension: " + info.extension;
            this.wdExtension = info.extension;
            cmd.extension = info.extension;
          }
          if (info.native!=null) {
            if (this.extensionVersion!="") {
              this.extensionVersion += ", ";
            }
            this.extensionVersion += "Native: " + info.native;
            this.wdNative = info.native;
            cmd.native = info.native;
          }
        } catch (e) {
        }
        this.playerChannel$.next( cmd );
        Log.d(logInfo, LogTag.CHROME_EXTENSION, 'wd started');
        this.pingInterval = setInterval(() => {
          Log.d(logInfo, LogTag.CHROME_EXTENSION, 'countSlowFPS=' + this.countSlowFPS);
          if (this.countSlowFPS < 5) {
            Log.d(logInfo, LogTag.CHROME_EXTENSION, 'ping');
            this.extension.call('ping').subscribe(ret => {
              Log.d(logInfo, LogTag.CHROME_EXTENSION, ret);
            });
          } else {
            clearInterval(this.pingInterval);
            this.pingInterval = null;
            location.reload();
          }
        }, 10000);



      }
      return of(null);
    })
  }

  reload() {
    if (this.extension.isInstalled) {
      this.extension.call('restartPlayer').subscribe();
    } else {
      location.reload();
    }
  }

  close() {
    const logInfo = Log.getLogInfo("Watchdog", "close", []);
    if (this.extension.isInstalled) {
      this.extension.call('close').subscribe( ret => {
        if (ret=='closed') {
          Log.d(logInfo, LogTag.CHROME_EXTENSION, 'watchdog got closed');
        }
        window.close();
      })
    } else {
      window.close();
    }
  }

  screenCapture(businessDomain: string, businessId: number, stationId: number, fileName: string, scale: number) {
    const logInfo = Log.getLogInfo("Watchdog", "screenCapture", []);
    if ((this.extension instanceof ChromeExtension) && this.extension.isInstalled) {
      this.extension.call('screenCapture', {
        businessDomain: businessDomain,
        businessId: businessId,
        stationId: stationId,
        fileName: String(fileName),
        scale: Number(scale)
      }).subscribe(value => {
        Log.d(logInfo, LogTag.CHROME_EXTENSION, 'screenCapture completed');
      })
    } else {
      var mainDiv = document.getElementById('mainDiv');
      html2canvas(mainDiv, {allowTaint: true, useCORS: false, backgroundColor: "rgba(0,0,0,0)"}).then((canvas) => {
        const newWidth = canvas.width * scale;
        const newHeight = canvas.height * scale;
        const newCanvas = document.createElement('canvas');
        newCanvas.width = newWidth;
        newCanvas.height = newHeight;
        const ctx = newCanvas.getContext('2d');
        ctx.drawImage(canvas,0,0,canvas.width,canvas.height,0,0,newWidth,newHeight);
        newCanvas.toBlob(imageBlob => {
          Log.d(logInfo, LogTag.PLAYER, 'blob success ' + imageBlob.size)
          const uploadURL = 'https://' + businessDomain + '/WebService/ScreenCaptureUpload.aspx?businessId=' + businessId + '&stationId=' + stationId;
          let formData = new FormData();
          formData.append("image", imageBlob, fileName + ".jpg");
          fetch(uploadURL, {
            method: 'POST',
            body: formData
          });
        }, 'image/jpeg')
      })
    }
  }

  private b64toBlob(b64Data, sliceSize = 512) {
    const BASE64_MARKER = ';base64,';
    if (b64Data.indexOf(BASE64_MARKER) == -1) {
      return;
    }
    const parts = b64Data.split(BASE64_MARKER);
    const contentType = parts[0].split(':')[1];

    const byteCharacters = atob(parts[1]);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, {type: contentType});
  }

  private blobToFile = (theBlob: Blob, fileName: string): File => {
    return new File([theBlob], fileName, {
      lastModified: new Date().getTime(),
      type: theBlob.type
    });
  };

  readLog() {
    this.extension.call('readLog').subscribe( value => {
      if (value!=null) {
        alert(value);
      }
    })
  }

  clearLog() {
    this.extension.call('clearLog').subscribe( value => {
      if (value!=null) {
        alert('log clear');
      }
    })
  }

  testHung() {
    const logInfo = Log.getLogInfo("Watchdog", "testHung", []);
    Log.d(logInfo, LogTag.CHROME_EXTENSION,'hung');
    while (true) {
    }
  }

  testSlow() {
    const logInfo = Log.getLogInfo("Watchdog", "testSlow", []);
    Log.d(logInfo, LogTag.CHROME_EXTENSION,'slow');
    setInterval(()=> {
      const t1 = new Date().getTime();
      while (true) {
        const t2 = new Date().getTime();
        if (t2-t1>1000) {
          break;
        }
      }
    },1)
  }


  testAbnormalExit() {
    window.close();
  }


  testInfiniteMemLeak() {
    this.memoryLeak = [];
    setInterval(()=> {
      this.countSlowFPS = 0; // prevent "no pings" on slow FPS
      this.memoryLeak.push( new Array(10000000) );
    }, 500);
  }

  testInfiniteDomLeak() {
    setInterval(()=> {
      let a=0;
      while(a<100) {
        this.countSlowFPS = 0; // prevent "no pings" on slow FPS
        const div = document.createElement('div');
        div.innerText = "DIV";
        div.style.position = "absolute";
        div.style.fontSize = '24px';
        div.style.left = Math.random() * 1000 + 'px';
        div.style.top = Math.random() * 1000 + 'px';
        div.style.color = 'rgb('+Math.random() * 256+', '+Math.random() * 256+', '+Math.random() * 256+')';
        document.body.appendChild(div);

        a++;
      }
    }, 100);

  }

  reboot() {
    this.extension.call('reboot').subscribe();
  }

}
